import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgxQrcodeStylingComponent } from 'ngx-qrcode-styling';
import { environment } from '../../../../environments/environment';
import { ControlMatch } from '../models/control-state';

@Component({
  selector: 'app-show-qr-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, NgxQrcodeStylingComponent],
  templateUrl: './show-qr-dialog.html',
  styleUrl: './show-qr-dialog.scss',
})
export class ShowQrDialogComponent implements OnInit {
  private data: { match: ControlMatch } = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<ShowQrDialogComponent>);

  match!: ControlMatch;
  qrConfig: any;
  refereeUrl = '';

  ngOnInit(): void {
    this.match = this.data.match;
    this.refereeUrl = environment.urlApp + 'referee/' + this.match.code;
    this.qrConfig = {
      width: 240,
      height: 240,
      margin: 16,
      data: this.refereeUrl,
      image: 'images/no-avatar.png',
      qrOptions: { errorCorrectionLevel: 'M' },
      backgroundOptions: { color: '#faf9fd' },
      template: 'bitcoin',
    };
  }

  get player1Name(): string {
    return this.match.player1?.playerName || this.match.player1Id || '?';
  }

  get player2Name(): string {
    return this.match.player2?.playerName || this.match.player2Id || '?';
  }

  close(): void {
    this.dialogRef.close();
  }
}
